// src/api/FetchUserArtistProfiles.ts
import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore, auth } from '../config/FirebaseConfig';
import toCamelCase from '../logic/toCamelCase';
import { Participant } from '../data/classes/Participant';

const FetchUserArtistProfiles = async (): Promise<Participant[]> => {
  const userArtistProfiles: Participant[] = [];

  if (auth.currentUser) {
    const q = query(
      collection(firestore, "Artists"),
      where("UserID", "==", auth.currentUser.uid)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.docs.forEach((doc) => {
      userArtistProfiles.push(
        toCamelCase({ id: doc.id, ...doc.data() }) as Participant
      );
    });
  }

  return userArtistProfiles;
};

export default FetchUserArtistProfiles;
